import api from "./core";

const basePath = "api/core/BillingDocument";

export default {
  query(data, extraHeaders = null) {
    return api.post(`${basePath}`, data, extraHeaders);
  },
  queryImproved(data, extraHeaders = null) {
    return api.post(`${basePath}/QueryImproved`, data, extraHeaders);
  },
  delete(id, extraHeaders = null) {
    return api.delete(`${basePath}/${id}`, extraHeaders);
  }
};
